export const ACTUALIZAR_PRODUCTOS = "ACTUALIZAR_PRODUCTOS";
export const ACTUALIZAR_PRODUCTOS_DB = "ACTUALIZAR_PRODUCTOS_DB";
export const CARGANDO_PROD = "CARGANDO_PROD";
export const FINALIZAR_CARGA_PROD = "FINALIZAR_CARGA_PROD";
export const ERROR_PROD = "ERROR_PROD";
export const LIMPIAR_ERROR = "LIMPIAR_ERROR";